import { NgModule } from '@angular/core';
import { SafeAssetPathPipe } from './safe-asset-path.pipe';

@NgModule({
  declarations: [SafeAssetPathPipe],
  providers: [SafeAssetPathPipe],
  exports: [SafeAssetPathPipe],
})
export class SafeAssetPathPipeModule {}
